import { useQuery } from '@tanstack/react-query'

import { weekendsServices } from './weekends-services'
import type { WeekendsQueryParams } from './work-schedules-services-types'

export const useWeekends = (params: WeekendsQueryParams) => {
  return useQuery({
    queryKey: ['week-ends'],
    queryFn: () => weekendsServices.get(params)
  })
}
